import { useFomaularioStorage } from '../../../storage'

export default function Certificado() {
    const { userData } = useFomaularioStorage(state => state.dados)

    const {
        nome = '',
        /* escolaridade = '', */
        instituicao = '',
        curso = '',
       /*  rg = '', */
        codigoUso = '',
        imagem = '',
        cpf = '',
        dataNascimento = '',
    } = Array.isArray(userData) ? userData[0] || {} : userData || {}

    const text = ` atesta que ${nome?.toUpperCase()} é estudante e está regularmente matrículado(a) em ${curso} na instituição ${instituicao}.`
    const text2 = 'MeiaEstudante.org.br não se responsabiliza por nenhum tipo de irregularidade na matrícula.'
    const valiText = 'Validação de CIE (Carteira de Identidade Estudantil)'

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            maxWidth: '500px',
            backgroundColor: '#f9fafb',
            padding: '10px',
            /*  borderRadius: '10px',
             boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', */
            fontFamily: 'sans-serif',
            margin: '20px 5px',
            boxSizing: 'border-box',
        }}>
            <h3 style={{
                fontSize: '20px',
                color: '#8BD5EF',
                marginBottom: '15px',
                fontWeight: '600',
            }}>{valiText}</h3>

            <div style={{
                backgroundColor: '#E1F5EC',
                padding: '10px',
                borderRadius: '8px',
                border: '2px solid #b8ebcd',
                textAlign: 'center',
                marginBottom: '20px',
            }}>
                <h3 style={{
                    fontSize: '12px',
                    color: '#00ab3e',
                    margin: 0,
                    fontWeight: '600',
                }}>
                    DOCUMENTO VÁLIDO
                </h3>
            </div>

            <div style={{
                fontSize: '12px',
                color: '#333',
                textAlign: 'left',
                marginBottom: '20px',
                lineHeight: '1.5',
            }}>
                <b>UNAE</b>{text}<br />
                {text2}
            </div>
            <div style={{ width: '100%', borderBottom: '2px solid #3939391a' , marginBottom: '20px'}}></div>
            <div style={{
                backgroundColor: '#F9FAFB',
                /* borderRadius: '8px', */
                padding: '5px',
                /* border: '1px solid #E5E7EB', */
                width: '100%',
                boxSizing: 'border-box',
                marginBottom: '20px'
            }}>


                <div style={{
                    display: 'flex',
                    gap: '8px',
                    /* alignItems: 'flex-start' */
                    flexDirection: 'column-reverse',
                }}>
                    {imagem && (
                        <img
                            src={imagem}
                            alt="Foto do estudante"
                            style={{
                                alignSelf: 'center',
                                width: '70px',
                                height: '90px',
                                objectFit: 'cover',
                                borderRadius: '8px',
                                border: '1px solid #ccc',
                            }}
                        />
                    )}

                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <div style={{
                            fontWeight: '600',
                            fontSize: '14px', 
                            color: '#111'
                        }}>Dados do estudante:</div>
                        <InfoField label="Nome:" value={nome} />
                        <InfoField label="Instituição:" value={instituicao} />
                        <InfoField label="Curso:" value={curso} />
                        <InfoField label="CPF:" value={formatarCPF(cpf)} />
                        <InfoField label="Data de Nascimento:" value={dataNascimento} />
                        <InfoField label="Código de uso:" value={codigoUso} />
                        <InfoField label="Emissor:" value="UNAE" />
                    </div>
                </div>
            </div>
        </div>
    )
}

function InfoField({ label, value }) {
    return (
        <div style={{ display: 'flex' }}>
            <h4 style={{
                width: '100%',
                fontSize: '12px',
                fontFamily: 'Roboto',
                fontWeight: '400'
            }}><b style={{ marginRight: '2px' }}>{label}</b>{value}</h4>
        </div>
    )
}

function formatarCPF(cpf) {
    // Remove tudo que não for número
    cpf = cpf.replace(/\D/g, '');

    // Aplica a máscara
    return cpf
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
}
